import Input from "./Input";
import { format } from "date-fns";
import PropTypes from "prop-types";
import { IconCalendar } from "@tabler/icons-react";

const propTypes = {
  onChange: PropTypes.func,
};

function InputPicker({ onChange, ...props }) {
  const id = `native-data-picker-${props?.id || 0}`;

  const onDateChange = (e) => {
    const date = new Date(e.target.value);
    if (onChange) {
      onChange(format(date, "dd/MM/yyyy"));
    }
  };

  const onClick = (e) => {
    const input = document.getElementById(id);
    input.showPicker();
  };

  return <Input {...props} id={id} type="date" onChange={onDateChange} iconLeft={<IconCalendar onClick={onClick} />} />;
}

InputPicker.propTypes = propTypes;
export default InputPicker;
